import {StyleSheet} from 'react-native';
import font from '@buncha/appStyles/style/font';

export const WrongItemScanAlertStyle = StyleSheet.create({
  image: {
    height: 50,
    width: 50,
  },
  alertMessage: {
    marginBottom: 10,
  },
  itemContainer: {
    alignItems: 'center',
    marginBottom: 10,
  },
  pickItem: {
    alignItems: 'center',
    paddingVertical: 5,
    paddingHorizontal: 10,
    borderRadius: 50,
    marginBottom: -12,
    zIndex: 10,
  },
  itemDetailsContainer: {
    justifyContent: 'flex-start',
    alignItems: 'center',
    borderWidth: 1,
    padding: 10,
    borderRadius: 10,
  },
  itemName: {
    textAlign: 'left',
    flex: 1,
    marginLeft: 10,
  },
  doNotPickContainer: {
    marginBottom: 5,
  },
  doNotPickText: {
    fontFamily: font.fontTheme.muli[700].normal,
  },
  textDecorationLine: {
    textDecorationLine: 'underline',
  },
});
